import { getPlans } from '../../api/authApi'
import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { setPlansAction } from '../../store/global/action'
import { Card, Space } from 'antd'
import { useEffect } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { Outlet, useLocation } from 'react-router-dom'
import { compose } from 'redux'

const SalesCampaignsContainer = (props: ConnectedProps<typeof withConnect>) => {
  const location = useLocation()

  const getNavBarTitle = () => {
    const pathName = location.pathname
    if (pathName.match(/^\/sales-campaigns\/[0-9]+$/)) {
      return translate('navBar.viewSalesCampaignTitle')
    }
    if (pathName.match(/^\/sales-campaigns\/new$/)) {
      return translate('navBar.newSalesCampaign')
    }
    if (pathName.match(/^\/sales-campaigns\/[0-9]+\/edit$/)) {
      return translate('navBar.editSalesCampaign')
    }
    return translate('navBar.salesCampaignsTitle')
  }

  useEffect(() => {
    getPlans({ page: 0, size: 999, type: 3 }).then(res => {
      const { setPlansAction } = props
      const miniProgramSelectablePlan = res.data.filter((item: any) => item.miniProgramSelectable)
      setPlansAction(miniProgramSelectablePlan)
    })
  }, [])

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar title={getNavBarTitle()}></NavBar>
      <Card>
        <Outlet />
      </Card>
    </Space>
  )
}

const mapDispatchToProps = {
  setPlansAction,
}

const withConnect = connect(null, mapDispatchToProps)

export default compose(withConnect)(SalesCampaignsContainer)
